import { useHistory, useParams } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmBox, CmCard } from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import { redirect404Page } from '@/lib/AccessControl';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

import StoreSettingForm from './components/StoreSettingForm';

const CamelKioskStorePage: React.FC = () => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_kiosk_account_management', history, managerAccountMe);

  const { id } = useParams<{ id: string }>();

  return (
    <PageLayout title={routes.CamelKioskStore.title}>
      <CmBox mt="24px">
        <CmBackLink color="#F5A128" to="/camel-kiosk/accounts">
          一覧に戻る
        </CmBackLink>
      </CmBox>
      <CmCard padding="24px" mt="16px" height={`calc(100vh - 120px)`}>
        <StoreSettingForm accountId={id} />
      </CmCard>
    </PageLayout>
  );
};

export default CamelKioskStorePage;
